// src/features/delegations/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import DelegationListPage from './pages/DelegationListPage';
import CreateDelegationPage from './pages/CreateDelegationPage';
import DelegationDetailPage from './pages/DelegationDetailPage';
import RevisionDiffPage from './pages/RevisionDiffPage';

export const DelegationRoutes = () => (
  <Route path="delegations">
    <Route
      index
      element={
        <ProtectedRoute requiredScope="delegation:read">
          <DelegationListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="create"
      element={
        <ProtectedRoute requiredScope="delegation:create">
          <CreateDelegationPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":delegationId"
      element={
        <ProtectedRoute requiredScope="delegation:read">
          <DelegationDetailPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":delegationId/revisions/:revisionId"
      element={
        <ProtectedRoute requiredScope="delegation:read">
          <RevisionDiffPage />
        </ProtectedRoute>
      }
    />
  </Route>
);
